/**
 * @generated SignedSource<<d8c0a0eb070ac4eec53fb1035c1a8ef4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleSectionHeaderSummaryOccasions_teamSchedule$data = ReadonlyArray<{
  readonly status: RoutineOccasionStatus;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderStatusDot_routineOccasion">;
  readonly " $fragmentType": "TeamScheduleSectionHeaderSummaryOccasions_teamSchedule";
}>;
export type TeamScheduleSectionHeaderSummaryOccasions_teamSchedule$key = ReadonlyArray<{
  readonly " $data"?: TeamScheduleSectionHeaderSummaryOccasions_teamSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummaryOccasions_teamSchedule">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TeamScheduleSectionHeaderSummaryOccasions_teamSchedule",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "calculateNoTasks",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "calculateNotCompletedStarted",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "status",
      "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleSectionHeaderStatusDot_routineOccasion"
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "2ebc2f2f82286909f175541a045dda83";

export default node;
